import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6938471f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  type: "button",
  title: "Filtrera",
  class: "btn btn-default btn-sm dropdown-toggle",
  "data-bs-toggle": "dropdown"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "caret" }, null, -1))
const _hoisted_3 = { class: "dropdown-menu" }
const _hoisted_4 = ["data-value"]
const _hoisted_5 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", _hoisted_1, [
      _createElementVNode("span", {
        class: _normalizeClass(["fa fa-filter", { hasFilters: _ctx.hasItems == true }])
      }, null, 2),
      _hoisted_2
    ]),
    _createElementVNode("ul", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.items, (item, index) => {
        return (_openBlock(), _createElementBlock("li", { key: index }, [
          _createElementVNode("a", {
            href: "#",
            class: "dropdown-item",
            "data-value": item,
            tabIndex: "-1"
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              value: item,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.checkedItems) = $event)),
              onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSelectionChanged && _ctx.onSelectionChanged(...args)))
            }, null, 40, _hoisted_5), [
              [_vModelCheckbox, _ctx.state.checkedItems]
            ]),
            _createTextVNode(" " + _toDisplayString(item), 1)
          ], 8, _hoisted_4)
        ]))
      }), 128))
    ])
  ]))
}